class SortingService {
    static sortByPriority(tasks) {
        const order = {
            high: 1,
            medium: 2,
            low: 3,
        };
        return [...tasks].sort((a, b) => {
            const getPriorityValue = (p) => order[p?.toLowerCase() ?? ''] ?? 4;
            return getPriorityValue(a.priority) - getPriorityValue(b.priority);
        });
    }
}
export default SortingService;
